import { FormEvent } from 'react';
import { RUB } from '../../../../../utils/char';
import { composeValidators } from '../../../../../utils/validators/compose';
import { makeIntegerValidator } from '../../../../../utils/validators/makeIntegerValidator';
import { makeRequiredValidator } from '../../../../../utils/validators/makeRequiredValidator';
import { IconClose } from '../../../../icon/IconClose';
import { IconButton } from '../../../../input/IconButton';
import { Input as InputBase } from '../../../../input/Input';
import { makeTextControlValidate } from '../../../../input/makeTextControlValidate';
import { Flex } from '../../../../layout/Flex';
import { Typography } from '../../../../typography/Typography';
import { Wrapper } from './styles';
import { ContentPromotionBudgetGoalProps } from './types';

const Input = makeTextControlValidate(InputBase);

const validator = composeValidators(
    makeRequiredValidator<string>(),
    makeIntegerValidator<string>(),
);

export const ContentPromotionBudgetGoal: React.FC<ContentPromotionBudgetGoalProps> = ({
    goals,
    selectedGoals,
    hiddenValue = false,
    onRemove,
    onChange,
}) => {
    if (!goals) {
        return null;
    }

    const endAdornment = (
        <Typography ml={1} variant="body">
            {RUB}
        </Typography>
    );

    return (
        <Wrapper>
            {goals.map((goal) => {
                const value = selectedGoals?.[goal.id];

                return (
                    <Flex
                        key={goal.id}
                        py={2}
                        direction="row"
                        width="100%"
                        alignItems="center"
                        justifyContent="space-between"
                    >
                        <Flex>
                            <Typography variant="body">{`${goal.id} • ${goal.name}`}</Typography>
                            <Typography variant="caption" color="secondary">
                                {goal.counterId}
                            </Typography>
                        </Flex>
                        <Flex
                            direction="row"
                            width="30%"
                            minWidth={140}
                            ml={1}
                            justifyContent="flex-end"
                        >
                            {hiddenValue ? null : (
                                <Input
                                    key={goal.id}
                                    type="number"
                                    variant="outline"
                                    onInput={(event: FormEvent<HTMLInputElement>) =>
                                        onChange(goal.id, event.currentTarget.value)
                                    }
                                    endAdornment={endAdornment}
                                    value={value ? value.toString() : undefined}
                                    min="0"
                                    step="1"
                                    validator={validator}
                                />
                            )}
                            <IconButton pl={2} onClick={() => onRemove(goal.id)}>
                                <IconClose />
                            </IconButton>
                        </Flex>
                    </Flex>
                );
            })}
        </Wrapper>
    );
};
